import { Link } from "react-router-dom";
import type { Film } from "@/types";
import FilmCard from "@/components/feature/FilmCard";

interface LatestFilmsProps {
  films: Film[];
}

export default function LatestFilms({ films }: LatestFilmsProps) {
  return (
    <section className="px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <h2 className="font-heading font-semibold text-2xl md:text-3xl text-foreground-950">
            最新影视内容
          </h2>
          <p className="mt-1.5 text-sm text-foreground-600">
            最新上线与更新的影视作品，第一时间掌握
          </p>
        </div>
        <Link
          to="/category?sort=latest"
          className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
        {films.map((film) => (
          <FilmCard key={film.id} film={film} />
        ))}
      </div>
    </section>
  );
}